import React, { useState, useEffect } from "react";
import CityServices from "services/CityServices";
import Select from "react-select";
const SelectCityAll = ({
  register,
  handleCityChange,
  selectedState,
  selectedCity,
  name,
  label,
}) => {
  const [cities, setCity] = useState([]);

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)",
        color: "black",
      },
    }),
    menu: (provided) => ({
      ...provided,
      margin: "10px 0 -10px 0",
      zIndex: "55555",
      overflow: "hidden",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "150px",
      overflowY: "scroll",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
  };

  useEffect(() => {
    if (selectedState) {
      async function fetchCity() {
        try {
          const response = await CityServices.getCityByStateId(selectedState);
          const transformedData = response.map((item) => ({
            value: item.id_city,
            label: item.name,
            call_prefix: item.call_prefix,
          }));
          setCity(transformedData);
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      }

      fetchCity();
    }
  }, [selectedState]);
  const handleCitySelect = async (selected) => {
    const item = cities.find((item) => item.value === selected.value);
    if (item) {
      handleCityChange(selected.value);
    }
  };

  return (
    <Select
      className="block w-full text-sm focus:outline-none dark:text-white-300 leading-5 rounded-md focus:border-white-200 focus:ring focus:ring-green-300 dark:focus:border-white-500 dark:focus:ring-gray-300 dark:bg-gray-700 border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      // isSearchable={false}
      {...register(`${name}`, {
        required: !selectedCity ? `${label} is required!` : false,
      })}
      defaultValue={cities[0]}
      name={name}
      styles={customSelectStyles}
      options={cities}
      onChange={handleCitySelect}
      value={cities.find(
        (option) => Number(option.value) === Number(selectedCity)
      )}
    />
  );
};

export default SelectCityAll;
